import _kebabCase from 'lodash/kebabCase';
import { Google } from '../analytics/index.js';
export const fbaMoneyBackGuaranteeClick = (_ref, option) => {
  let {
    event
  } = _ref;
  const textContent = (event?.target?.innerText || event?.target?.textContent || '').trim();
  const linkCopy = _kebabCase(textContent);
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventAction: 'search',
    eventResult: `text-link::${linkCopy}`,
    eventNonInteractive: true
  }, option);
  return {
    cmp: linkCopy
  };
};
export const fbaCompareContentClick = (_ref2, option) => {
  let {
    data = {},
    event
  } = _ref2;
  const textContent = (event?.target?.innerText || event?.target?.textContent || '').trim();
  const linkCopy = textContent.replace(/\s+/g, '-').toLowerCase();
  const {
    section
  } = data;
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventAction: 'search',
    eventResult: `text-link::compare-${section}::${linkCopy}`,
    eventNonInteractive: true
  }, option);
  return {
    cmp: linkCopy,
    section
  };
};
export default {
  fbaMoneyBackGuaranteeClick,
  fbaCompareContentClick
};